"use client";

import React, { ReactNode, useRef } from 'react';
import AccordionItem from '@/components/accordionItem';

// Style Imports
import styles from "./accordion.module.scss";
import classNames from "classnames";

/**
 * A component to display an accordion view of content.
 *
 * @param children - The content to be displayed inside the accordion panels
 */
interface AccordionProps {
  children: ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({
  children
}) => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const accordionlistRef = useRef<HTMLDivElement | null>(null);
  const [selectedAccordion, setSelectedAccordion] = React.useState<number | null>(null);

  const handleAccordionClick = (index: number) => {
    // Toggle the selected accordion: close if it's already open
    setSelectedAccordion(prev => (prev === index ? null : index));
  };

  const classes = [styles.accordion];

  return (
    <section className={classNames(classes)} ref={sectionRef}>
      <div
        className={styles.accordionlist}
        ref={accordionlistRef}
      >
        {/* set selected accordion and pass to AccordionItem */}
        {/* eslint-disable @typescript-eslint/no-explicit-any */}
        {React.Children.map(children, (child, index) => (
          React.cloneElement(child as React.ReactElement<any>, {
            selected: selectedAccordion === index,
            index,
            onClick: () => handleAccordionClick(index),
          })
        ))}
      </div>
    </section>
  );
};

export { Accordion, AccordionItem };
